import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

const N = 9;
const DURATION = 20;

export function ReflexGrid({ onScore }) {
  const [lit, setLit] = useState(-1);
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(DURATION);
  const [running, setRunning] = useState(false);
  const [over, setOver] = useState(false);
  const reported = useRef(false);

  const relight = () => setLit(Math.floor(Math.random() * N));

  const start = () => { setScore(0); setTime(DURATION); setRunning(true); setOver(false); reported.current = false; relight(); };

  useEffect(() => {
    if (!running) return;
    if (time <= 0) { setRunning(false); setOver(true); setLit(-1); return; }
    const t = setTimeout(() => setTime((x) => x - 1), 1000);
    return () => clearTimeout(t);
  }, [running, time]);

  const tap = (i) => { if (!running) return; if (i === lit) { setScore((s) => s + 1); relight(); } };
  useEffect(() => { if (over && !reported.current) { reported.current = true; onScore?.(score * 40); } }, [over, score, onScore]);

  return (
    <div className="flex flex-col items-center" data-testid="reflex-grid">
      <div className="flex gap-6 mb-4 font-mono">
        <span className="text-neon-cyan text-lg" data-testid="reflex-score">HITS: {score}</span>
        <span className={`text-lg ${time <= 5 ? "text-neon-pink animate-blink" : "text-neon-yellow"}`}>⏱ {time}s</span>
      </div>
      <div className="relative grid grid-cols-3 gap-2 p-2 bg-zinc-900 border-2 border-zinc-700 rounded-xl" style={{ width: "min(88vw, 320px)" }}>
        {Array.from({ length: N }).map((_, i) => (
          <button key={i} onClick={() => tap(i)} data-testid={`reflex-cell-${i}`}
            className="aspect-square rounded-lg transition-all"
            style={{ background: lit === i ? "#39FF14" : "#27272a", boxShadow: lit === i ? "0 0 16px #39FF14" : "none" }} />
        ))}
        {!running && (
          <div className="absolute inset-0 bg-black/85 rounded-xl flex flex-col items-center justify-center gap-3">
            {over && <p className="font-display font-black text-2xl text-neon-lime uppercase" data-testid="reflex-over">Time! {score} hits</p>}
            <Button onClick={start} data-testid="reflex-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase">
              <Play className="w-4 h-4 mr-1 fill-black" /> {over ? "Play Again" : "Start"}
            </Button>
          </div>
        )}
      </div>
      <p className="text-zinc-500 text-xs font-mono mt-3">Tap the green tile as fast as it appears!</p>
    </div>
  );
}
